module.exports = __webpack_public_path__ + "static/media/default-image.4b9dffa7.png";